export default __webpack_public_path__ + "static/media/line-drawing.8bb04169.svg";